import { http } from '../../../../api/http';
import type {
  ReporteMargen,
  ReporteVentasPeriodo,
  ReporteVentasCliente,
  ReporteVentasVendedor,
  FiltroReporte,
} from '../types/reporte.types';

export class ReporteVentaService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/reporte',
  };

  public static async getMargenes(filtro?: FiltroReporte): Promise<ReporteMargen[]> {
    try {
      const params = new URLSearchParams();
      if (filtro?.fechaDesde) params.append('fechaDesde', filtro.fechaDesde);
      if (filtro?.fechaHasta) params.append('fechaHasta', filtro.fechaHasta);

      const response = await http.get(`${this.ENDPOINTS.BASE}/margenes?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reporte margenes:', error);
      throw error;
    }
  }

  public static async getVentasPeriodo(anio: number): Promise<ReporteVentasPeriodo[]> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/ventas-periodo/${anio}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ventas periodo:', error);
      throw error;
    }
  }

  public static async getVentasCliente(filtro?: FiltroReporte): Promise<ReporteVentasCliente[]> {
    try {
      const params = new URLSearchParams();
      if (filtro?.fechaDesde) params.append('fechaDesde', filtro.fechaDesde);
      if (filtro?.fechaHasta) params.append('fechaHasta', filtro.fechaHasta);

      const response = await http.get(`${this.ENDPOINTS.BASE}/ventas-cliente?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ventas cliente:', error);
      throw error;
    }
  }

  public static async getVentasVendedor(filtro?: FiltroReporte): Promise<ReporteVentasVendedor[]> {
    try {
      const params = new URLSearchParams();
      if (filtro?.fechaDesde) params.append('fechaDesde', filtro.fechaDesde);
      if (filtro?.fechaHasta) params.append('fechaHasta', filtro.fechaHasta);

      const response = await http.get(`${this.ENDPOINTS.BASE}/ventas-vendedor?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ventas vendedor:', error);
      throw error;
    }
  }
}
